import { motion } from "framer-motion";
import { LuLinkedin } from "react-icons/lu";
import { useLang } from "../i18n";
import { teamContent } from "../data/content";
import "./Team.css";

/**
 * Team-grid i masonry-ish layout. Korten har photo-cover, tydlig roll, och en
 * "glow"-edge på hover. Alla bios är ungefär lika långa, så de visas i sin
 * helhet utan klipp/expand.
 */
export default function Team() {
  const { t } = useLang();
  const members = teamContent.members;

  return (
    <section id="team" className="team">
      <div className="container">
        <motion.header
          className="team-header"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.5 }}
        >
          <span className="section-eyebrow">{t(teamContent.eyebrow)}</span>
          <h2 className="section-heading">{t(teamContent.title)}</h2>
        </motion.header>

        <div className="team-grid">
          {members.map((m, idx) => (
            <motion.article
              key={m.name}
              className="team-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.5, delay: (idx % 4) * 0.08 }}
            >
              <div className="team-photo">
                <img
                  src={m.photo}
                  alt={m.name}
                  loading="lazy"
                  style={{ objectPosition: m.objectPosition ?? "center 18%" }}
                />
                {m.linkedin && (
                  <a
                    className="team-linkedin"
                    href={m.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`LinkedIn: ${m.name}`}
                  >
                    <LuLinkedin size={18} aria-hidden />
                  </a>
                )}
              </div>
              <div className="team-info">
                <h3>{m.name}</h3>
                <span className="team-role">{t(m.role)}</span>
                <p className="team-bio">{t(m.bio)}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
